export default {"src":"/_next/static/media/powerUpTransparent_72.1ce33b2a.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};